import { toast } from 'react-toastify'

const giveALongBreakTo = (day, userId, placeId) => {
  const intervals = day.intervals
    .toSorted((a, b) => new Date(a.start) - new Date(b.start))
    .filter((interval) => {
      return interval.sessions.some((session) => session.mg === userId)
    })
  const goals = [
    { h: 11, m: 15 },
    { h: 18, m: 15 },
    { h: 14, m: 45 },
  ]
  const goal = goals.find((goal) => {
    return intervals.some((interval) => {
      const start = new Date(interval.start)
      return start.getHours() === goal.h && start.getMinutes() === goal.m
    })
  })
  const interval = intervals.find((interval) => {
    const start = new Date(interval.start)
    return start.getHours() === goal.h && start.getMinutes() === goal.m
  })
  if (!interval) return toast.error('Un gamemaster est présent sur au moins 4 créneaux mais ne travaille pas lors des créneaux de pauses. La longue pause est impossible à attribuer.')
  const session = interval.sessions.find((s) => s.mg === userId)
  if (!session) return toast.error('Un gamemaster est présent sur au moins 4 créneaux mais ne travaille pas lors des créneaux de pauses. La longue pause est impossible à attribuer.')
  if (placeId && session?.room?.place_id !== placeId) return
  session.needLongBreak = true
}

const giveAShortBreakTo = (day, userId, placeId) => {
  const intervals = day.intervals
    .toSorted((a, b) => new Date(a.start) - new Date(b.start))

  // short breaks can only be taken at 5th interval (.i.e 16:20)
  const interval = intervals[4]

  // does the user have a session in this interval
  const session = interval.sessions.find((s) => s.mg === userId)
  if (!session) return toast.error(`Un gamemaster est présent sur 5 créneaux mais ne travaille pas à 16h20. La courte pause est impossible à attribuer.`)

  // does the user have a session in the right place
  if (placeId && session?.room?.place_id !== placeId) return

  session.needShortBreak = true
}

export const placeBreaks = (placeId, day, updateSessionValue) => {
  // remove all breaks
  const dayCopy = JSON.parse(JSON.stringify(day))
  dayCopy.intervals.forEach((interval) =>
    interval.sessions.forEach((s) => {
      if (s.needLongBreak && s?.room?.place_id == placeId) s.needLongBreak = false
      if (s.needShortBreak && s?.room?.place_id == placeId) s.needShortBreak = false
    })
  )

  // list users of the day with there count of sessions
  const o = dayCopy.intervals
    .map((interval) => interval.sessions)
    .flat()
    .filter((s) => s.mg)
    .map((s) => s.mg)
    .reduce((acc, cur) => ((acc[cur] = (acc[cur] || 0) + 1), acc), {})
  const usersIdsNeedingLongBreak = Object.keys(o)
    .map((key) => ({ _id: key, count: o[key] }))
    .filter((u) => u.count >= 4)
    .map((u) => u._id)

  const usersIdsNeedingShortBreak = Object.keys(o)
    .map((key) => ({ _id: key, count: o[key] }))
    .filter((u) => u.count >= 5)
    .map((u) => u._id)

  // give a break to each user
  usersIdsNeedingLongBreak.forEach((userId) => {
    giveALongBreakTo(dayCopy, userId, placeId)
  })

  usersIdsNeedingShortBreak.forEach((userId) => {
    giveAShortBreakTo(dayCopy, userId, placeId)
  })

  dayCopy.intervals.forEach((interval) => {
    const oldInterval = day.intervals.find((i) => i._id === interval._id)
    interval.sessions.forEach((session) => {
      const oldSession = oldInterval.sessions.find((s) => s._id === session._id)
      if (oldSession.needLongBreak !== session.needLongBreak) {
        updateSessionValue(
          dayCopy._id,
          interval._id,
          session._id,
          'needLongBreak',
          session.needLongBreak
        )
      }
      if (oldSession.needShortBreak !== session.needShortBreak) {
        updateSessionValue(
          dayCopy._id,
          interval._id,
          session._id,
          'needShortBreak',
          session.needShortBreak
        )
      }
    })
  })
}
